














import { Component, Prop, Vue } from 'vue-property-decorator'
import SelectBase from '@/components/common/atoms/SelectBase.vue'

export type SelectOption = {
  value: string | number
  text: string
  disabled?: boolean
}

@Component({
  components: {
    SelectBase,
  },
})
export default class SelectWithLabel extends Vue {
  @Prop()
  options!: SelectOption[]

  @Prop()
  size?: string

  @Prop({ default: null })
  labelcolor?: null | string

  get classObject(): { [key: string]: boolean } {
    const { size } = this
    return {
      'select-with-label__input__size-default': !size,
      'select-with-label__input__size-block': size === 'block',
    }
  }

  get setStyle(): { [key: string]: string } {
    let labelcolor = 'var(--color-gray-1)'
    switch (this.labelcolor) {
      case 'black':
        labelcolor = 'var(--color-black)'
        break
      case 'blue':
        labelcolor = 'var(--color-blue)'
        break
    }

    return {
      '--label-color': labelcolor,
    }
  }

  private changeSelect(event: Event): void {
    this.$emit('input', event)
  }
}
